import { render, staticRenderFns } from "./AgentForm.vue?vue&type=template&id=1d063c2e&scoped=true&"
import script from "./AgentForm.vue?vue&type=script&lang=js&"
export * from "./AgentForm.vue?vue&type=script&lang=js&"
import style0 from "./AgentForm.vue?vue&type=style&index=0&id=1d063c2e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d063c2e",
  null
  
)

export default component.exports